<template>
    <Navbar></Navbar>
    <div class="privacy-page">
        <div class="privacy-title">
            蜂巢汽车隐私政策
        </div>
        <div class="privacy-d1">
            蜂巢汽车科技集团有限公司（以下简称“我们”、"本公司"或"蜂巢汽车"）重视您的隐私，为此，我们制定了蜂巢汽车隐私政策（以下简称“本政策”），以帮助您充分了解您在使用我们网站（http://www.finestauto.com）的过程中，我们会如何收集、使用、共享、存储和保护您的个人信息，以及您可以如何行使您的个人信息主体权利。请您在使用我们的服务前，仔细阅读并了解本政策
        </div>
        <div class="privacy-t2">
            本政策将帮助您了解以下内容：
        </div>
        <div class="privacy-d1">
            一、隐私政策的发布主体和适用范围<br>
            二、摘要<br>
            三、个人信息的收集使用规则<br>
            四、个人信息的共享及公开披露<br>
            五、个人信息的存储及保护<br>
            六、用户权利<br>
            七、未成年人的信息保护<br>
            八、本隐私政策的更新和修订<br>
            九、联系我们
        </div>
        <div class="privacy-t1">
            一、隐私政策的发布主体和适用范围
        </div>
        <div class="privacy-d1">
            <span class="privacy-cb">1.1个人信息处理者：</span>蜂巢汽车科技集团有限公司（以下简称“蜂巢汽车”或“我们”），地址：河北省保定市莲池区东二环东盛路75号。<br>
            <span class="privacy-cb">1.2个人信息保护负责人联系方式：</span> cdfwhg@finestauto.com<br>
            <span class="privacy-cb">1.3本政策的适用范围：<br></span>
            <span
                class="privacy-cb privacy-fb">本隐私政策适用于蜂巢汽车向您提供的各项产品/服务。若蜂巢汽车的某些产品/服务单独设立隐私政策的，适用其特定的隐私政策。需要您注意的是，本隐私政策不适用于第三方通过蜂巢汽车的产品/服务向您提供的服务。</span>第三方收集和处理信息等行为遵循其自身的隐私政策，而不适用本隐私政策。但我们会充分审查第三方的资质，要求其保证所提供的产品/服务合法合规，并保护您的个人信息安全。<br>
            <span class="privacy-cb">1.4本政策适用的个人信息主体类型：</span>具备完全民事行为能力的自然人。<br>
            1.5本隐私政策的发布日期为2026年9月11日，并于2026年9月19日正式生效。
        </div>

        <div class="privacy-t1">
            二、摘要
        </div>
        <div class="privacy-d1">
            <div>
                我们的产品/服务涉及<span class="privacy-cb privacy-fb">内容资讯浏览</span>常用业务功能，在您使用这些功能时我们会在征得您的授权同意后收集您的
                <span
                    class="privacy-cb privacy-fb">访问设备信息、访问操作信息、网络状态信息、网络标识信息，</span>上述信息属于一般个人信息（个人信息是以电子或者其他方式记录的与已识别或者可识别的自然人有关的信息，不包括匿名化处理后的信息），我们不会收集您的敏感个人信息（敏感个人信息是一旦泄露或者非法使用，容易导致自然人的人格尊严受到侵害或者人身、财产安全受到危害的个人信息，包括生物识别、宗教信仰、特定身份、医疗健康、金融账户、行踪轨迹等信息，以及不满十四周岁未成年人的个人信息，如涉及上述信息的收集我们会在取得您的单独同意后收集），
                <span class="privacy-cb privacy-fb">具体信息的处理规则请您详见收集使用个人信息的规则部分以及附件《个人信息清单》《SDK清单目录》的内容展示。</span>
            </div>
            <div>
                为了向您提供更为优质的服务，我们会向第三方以及我们的关联单位共享您的个人信息，共享的范围以及共享的目的我们会通过《个人信息对外提供清单》向您展示。还请您知悉，我们仅在取得您的单独授权同意或在法律允许的情形下共享您的个人信息，您有拒绝我们对外共享您个人信息的权利。
            </div>
            <div>
                还请您知悉，您对您本人个人信息的处理享有知情权、决定权，您有权查阅、复制、更正、补充、删除、撤回同意以及要求解释说明的权利，若您有相关权利响应的需求，请您通过“联系我们”所列的联系方式与我们取得联系，我们将在规定的时间内响应您的请求。
            </div>
            <div>
                为使您的合法权益得到更好的保护，请您<span
                    class="privacy-cb privacy-fb">特别注意我们以下划线或粗体标识的条款。</span>我们已经建立便捷的投诉举报通道，您在使用我们的产品或服务过程中，有任何疑问、不满或我们未及时响应您的需求的，您可通过“联系我们”处所列的联系方式与我们取得联系，我们会第一时间响应您的需求。
            </div>
        </div>
        <div class="privacy-t1">
            三、个人信息的收集使用规则
        </div>
        <div class="privacy-d1">
            在您使用我们的产品或服务时，我们会基于最小范围以及必要的目的收集您的个人信息，在收集您的敏感个人信息时，我们将通过<span
                class="privacy-cb privacy-fb">粗体并加下划线</span>的形式进行标注，若确需改变信息收集和使用的目的，我们将会再次征得您的授权同意，并通过弹窗的方式向您进行告知，请您注意，具体处理规则如下：<span
                class="privacy-cb privacy-fb">（详细内容请您仔细阅读附件《个人信息清单》《SDK清单目录》）：</span><br>
        </div>


        <div class="privacy-t2">
            3.1我们如何使用Cookie和同类技术
        </div>
        <div class="privacy-d1">
            Cookie和设备信息标识等同类技术是互联网中普遍使用的技术。当您使用我们的产品/服务时，我们可能会使用相关技术向您的设备发送一个或多个Cookie或匿名标识符，以收集、标识和存储您访问、使用产品/服务时的信息。我们承诺，我们不会将Cookie用于本隐私政策所述目的之外的任何其他用途。<br>
            您有权决定接受或拒绝在网站中使用Cookie。您可以通过浏览器隐私设置修改对Cookie的接受程度或者拒绝Cookie，但拒绝Cookie在某些情况下您可能无法使用依赖于Cookie的服务的部分功能。以Microsoft
            Edge为例，您可以通过点击“设置-隐私、搜索和服务-Cookie”来管理网站的Cookie收集请求。
        </div>
        <div class="privacy-t2">
            3.2关于第三方SDK收集信息的说明
        </div>
        <div class="privacy-d1">
            为了保障我们的产品或服务能够安全稳定运行或实现相关功能，我们可能会接入第三方提供的软件开发包（“SDK”），当您在我们的产品或服务中使用第三方软件开发包提供的功能时，第三方SDK可能会收集您的个人信息。第三方SDK收集和处理信息等行为遵循第三方的隐私条款，而不适用于本隐私政策。但我们会充分审查第三方的资质，要求其保证所提供的产品/服务合法合规，并保护您的个人信息安全，<span
                class="privacy-cb privacy-fb">第三方SDK所收集的个人信息类型，以及所处理个人信息的目的、方式及频次等请查看附件《SDK清单目录》。</span>
        </div>

        <div class="privacy-t2">
            3.3无需征得您的同意收集个人信息的情形：
        </div>
        <div class="privacy-d1">
            您已充分知悉，在法律法规允许范围内，在下列情形中，我们可能会依法收集并使用您的个人信息且无需征得您的同意或授权：<br>
            （1）与国家安全、国防安全直接相关的；<br>
            （2）与公共安全、公共卫生、重大公共利益直接相关的；<br>
            （3）与犯罪侦查、起诉、审判和判决执行等司法或行政执法直接相关的；<br>
            （4）出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；<br>
            （5）所涉及的个人信息是您自行向社会公众公开的；<br>
            （6）根据您的要求签订和履行合同所必需的；<br>
            （7）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；<br>
            （8）维护所提供产品或服务的安全稳定运行所必需的，例如发现、处置产品/服务的故障；<br>
            （9）与我们履行法律规定的义务相关的；<br>
            （10）法律法规规定的其他情形。
        </div>

        <div class="privacy-t1">
            四、信息的共享及公开披露
        </div>
        <div class="privacy-t2">
            4.1共享
        </div>
        <div class="privacy-d1">
            我们不会向蜂巢汽车以外的任何第三方共享您的个人信息，但以下情形除外：<br>
            （1）法律规定情形下的共享：<br>
            我们可能会根据法律法规或行政、司法机关依法提出的要求，共享、披露您的个人信息。<br>
            （2）在获得您明确同意的情况下共享：<br>
            在获得您的明确同意及授权后，我们可能会与其他第三方共享您的个人信息。共享内容包括共享的信息类型及原因、个人信息接收方、对接收方的约束和管理机制等内容<span
                class="privacy-cb">请您详细阅读附件《个人信息对外提供清单》</span>。
        </div>
        <div class="privacy-t2">
            4.2公开披露 
        </div>
        <div class="privacy-d1">
            我们不会公开披露您的个人信息，但以下情形除外：<br>
            （1）获得您的明确同意而披露的信息；<br>
            （2）法律法规规定的其他情形。<br>
        </div>
        <div class="privacy-d1 privacy-cb">
            披露的请您详细阅读附件《个人信息对外披露清单》。
        </div>
        <div class="privacy-t2">
            4.3共享、公开披露个人信息时无需征得您授权同意的情形：
        </div>
        <div class="privacy-d1">
            （1）与国家安全、国防安全直接相关的；<br>
            （2）与公共安全、公共卫生、重大公共利益直接相关的；<br>
            （3）与犯罪侦查、起诉、审判和判决执行等司法或行政执法直接相关的；<br>
            （4）出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；<br>
            （5）所涉及的个人信息是您自行向社会公众公开的；<br>
            （6）根据您的要求签订和履行合同所必需的；<br>
            （7）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；<br>
            （8）维护所提供产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；<br>
            （9）与我们履行法律规定的义务相关的；<br>
            （10）法律法规规定的其他情形。
        </div>

        <div class="privacy-t1">
            五、信息的存储及保护
        </div>
        <div class="privacy-t2">
            5.1信息存储
        </div>
        <div class="privacy-d1">
            蜂巢汽车依照法律规定，将在中华人民共和国境内运营过程中收集及产生的您的个人信息存储于中华人民共和国境内。<br>
            我们仅在为实现本隐私政策所述目的所需期限内保留您的个人信息，法律法规另有规定或者您另行授权同意的除外。超出存储期限后，我们将会对您的个人信息进行删除或匿名化处理。<span
                class="privacy-cb">具体信息的储存位置及储存期限请您仔细阅读附件《个人信息清单》。</span>
        </div>
        <div class="privacy-t2">
            5.2信息保护
        </div>
        <div class="privacy-d1">
            我们已采用符合业界及国家法律要求标准的安全防护措施保护您的个人信息，防止数据遭到未经授权的访问、公开披露、修改、损坏或泄露。我们会从数据管理制度设计、数据保护技术加强、内部人员管理等多方面多维度加强对您的个人信息保护。我们采取严格的数据使用和访问制度，根据数据的敏感程度和类型的不同采取了数据分类分级制度，仅允许有必要知晓信息的人员访问个人信息，并设置了访问权限控制和监控机制。同时我们会对我们的员工进行信息安全和隐私保护方面的知识赋能，增强员工对于保护个人信息的意识。
        </div>
        <div class="privacy-d1">
            我们将竭尽全力保护您的个人信息安全，但请您理解，任何安全措施都无法做到100%安全，可能存在发生信息安全事件的风险，如果发生信息安全事件，我们会启动应急预案，采取必要的补救措施并将按照法律法规的要求24小时内向您告知基本情况及相应的措施。同时按照法律法规要求向有关主管机关进行报告，尽可能降低信息安全事件对您的影响，由此给您造成的损失，我们将在法律规定的范围内承担相应责任。如果您认为我们的系统存在任何安全风险或漏洞，请根据以下
            “联系我们”部分所列的方式与我们取得联系。
        </div>
        <div class="privacy-t1">
            六、用户权利
        </div>
        <div class="privacy-d1">
            我们非常重视并尽全力保护您对于您个人信息查阅、复制、更正、补充、删除、撤回同意的权利，以使您拥有充分的能力保障您的隐私和安全。您可以通过以下方式行使上述权利：
        </div>
        <div class="privacy-t2">
            6.1查阅权
        </div>
        <div class="privacy-d1">
            如果您想查阅您的个人信息，您可以随时通过以下“联系我们”部分所列的方式和我们取得联系，我们将在七日内完成身份核查和响应处理。
        </div>
        <div class="privacy-t2">
            6.2复制权
        </div>
        <div class="privacy-d1">
            您有权复制您的个人信息。如您需要复制我们收集的您的个人信息，您可通过以下“联系我们”部分所列的方式和我们取得联系，相关人员对您进行必要的身份核查后，在符合相关法律规定且技术可行的前提下，我们将根据您的要求提供您的个人信息副本。
        </div>
        <div class="privacy-t2">
            6.3更正、补充权
        </div>
        <div class="privacy-d1">
            当您发现我们处理的关于您的个人信息不准确或不完整时，经对您的身份进行核查，且更正、补充不影响信息的客观性和准确性的情况下，您有权对不准确或不完整的信息作出更正或补充。您可根据以下“联系我们”部分所列的方式与我们联系。
        </div>
        <div class="privacy-t2">
            6.4删除权
        </div>
        <div class="privacy-d1">
            如果我们违反法律法规或与您的约定收集或与他人分享您的个人信息，您有权要求我们删除。如您希望删除您的其他信息(包括敏感个人信息)，您可以根据以下“联系我们”部分所列的方式与我们联络，我们将在十日内删除。<br>
            当您或我们协助您删除相关信息后，因为适用的法律和安全技术限制，我们可能无法立即从备份系统中删除相应的信息，我们只会做存储不会进行其他用途直到在备份更新时删除或对这些信息做匿名化处理，同时，我们不会开展除存储和采取必要的安全保护措施之外的处理。
        </div>
        <div class="privacy-t2">
            6.5撤回权
        </div>
        <div class="privacy-d1">
            您可以通过删除信息、关闭功能的方式改变您授权我们收集和处理个人信息的范围或撤回您的授权。您也可以通过注销账户的方式，撤回我们继续收集和处理您个人信息的全部授权。<br>
            请您理解，每个业务功能需要一些基本的个人信息才能得以完成，当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的服务，也不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响此前基于您的授权而开展的个人信息处理。
        </div>

        <div class="privacy-t2">
            6.6注销权
        </div>
        <div class="privacy-d1">
            您可以通过以下“联系我们”部分所列的方式和我们取得联系，提交账户注销申请，审批通过后，注销此前注册的账户。账户注销可能会导致清除您的所有数据和账户信息且不可恢复，在注销账户之后，我们将停止为您提供产品/服务，并依据您的要求，删除您的个人信息，法律法规另有规定的除外。
        </div>

        <div class="privacy-t2">
            6.7用户请求的响应
        </div>
        <div class="privacy-d1">
            <div>
                为保障安全，您可能需要提供书面请求或以其他方式证明您的身份。我们会先核查您的身份，然后再处理您的请求。另外，您需要注意，我们收集的信息包含其他通过您的账户使用我们的产品/服务人员的个人信息，我们需要您对该部分人员行使权利的要求进行确认。除第6.4条删除您的个人信息的相关规定以外，
                我们将在七日内完成身份核查和处理响应。如果您的请求需要较长时间才能响应，无法在规定时间响应的，我们将及时与您取得联系，向您告知响应的时间节点以及无法响应的原因。如您对我们的响应结果不满意，还可以通过以下“联系我们”部分所列的方式进行投诉。<br>
            </div>
            <div>
                对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情况收取一定成本费用。对于那些无端重复、需要过多技术手段（例如开发新系统、从根本上改变行业惯例）、给他人合法权益带来风险或不切实际的请求，我们可能会予以拒绝。
            </div>
        </div>

        <div class="privacy-t2 p-l">
            在以下情形中，我们将无法响应您的请求：
        </div>
        <div class="privacy-d1 p-l">
            （1）与国家安全、国防安全直接相关的；<br>
            （2）与公共安全、公共卫生、重大公共利益直接相关的；<br>
            （3）与犯罪侦查、起诉、审判和判决执行等司法或行政执法直接相关的；<br>
            （4）出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；<br>
            （5）所涉及的个人信息是您自行向社会公众公开的；<br>
            （6）根据您的要求签订和履行合同所必需的；<br>
            （7）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；<br>
            （8）维护所提供产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；<br>
            （9）与我们履行法律规定的义务相关的；<br>
            （10）法律法规规定的其他情形。
        </div>


        <div class="privacy-t1">
            七、未成年人的信息保护
        </div>
        <div class="privacy-d1">
            7.1我们非常重视对未成年人个人信息的保护。如果国家相关法律法规规定，18周岁以下的未成年人不能购买或使用我们的产品/服务的，我们有权据此拒绝为您提供相关的产品和/或服务。除此以外，您使用我们的其他产品/服务前，应事先取得您的监护人的同意。
            7.2经监护人同意而收集未成年人个人信息时，我们只会在法律允许或监护人明确同意或者保护未成年人所必要的情况下使用此信息。<br>
            7.3如果我们发现在未事先获得可证实的监护人同意的情况下收集了未成年人的个人信息，我们会尽快删除相关数据。<br>
            7.4对于可能涉及的不满14周岁的儿童个人信息，我们进一步采取以下措施予以保障：<br>
            （1）对于收集到的儿童个人信息，我们除遵守本隐私政策关于您个人信息的约定外，还会秉持正当必要、知情同意、目的明确、安全保障、依法利用的原则，严格遵循《儿童个人信息网络保护规定》等法律法规的要求进行存储、使用、披露，且不会超过实现收集、使用目的所必须的期限，到期后我们会对儿童个人信息进行删除或匿名化处理。<br>
            （2）儿童或其监护人有权随时访问和更正儿童个人信息，还可以向我们提出更正和删除的请求。如您对儿童个人信息相关事宜有任何意见、建议或投诉、举报，请联系我们。我们会随时为您提供帮助。
        </div>

        <div class="privacy-t1">
            八、本隐私政策的更新和修订
        </div>
        <div class="privacy-d1">
            8.1本隐私政策会根据为您提供更高质量的服务目的及我们业务的发展进行更新，但未经您明确同意，我们不会减少您依据过往的隐私政策应享有的权利。<br>
            8.2如本隐私政策发生重大变更，我们会尽一切我们能够做到的方式给您提供显著的通知（包括但不限于在官网首页显著位置公示、通过站内信告知）、页面做特别提示等方式来说明本隐私政策的具体变更内容。本隐私政策所指的重大变更包括但不限于：<br>
            （1）我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；<br>
            （2）我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；<br>
            （3）个人信息共享、转让或公开披露的主要对象发生变化；<br>
            （4）您参与个人信息处理方面的权利及其行使方式发生重大变化；<br>
            （5）我们负责处理个人信息安全的责任部门、联系方式及投诉渠道发生变化时；<br>
            （6）数据安全能力、信息安全风险发生变化。<br>
            （7）其他涉及用户权益重大影响的隐私政策需要更新的情形。
        </div>

        <div class="privacy-t1">
            九、联系我们
        </div>
        <div class="privacy-d1">
            9.1如果您对本隐私政策有任何疑问、意见、建议、投诉您可通过以下方式与我们取得联系：<br>
            蜂巢汽车科技集团有限公司，注册地址：河北省保定市莲池区东二环东盛路75号，邮编：071000<br>
            邮箱：cdfwhg@finestauto.com<br>
            9.2一般情况下，我们将在七日内完成身份核查和处理响应。如果您对我们的回复不满意，特别是认为我们的个人信息处理行为损害了您的合法权益，您还可以向网信、电信、公安及工商等监管部门进行投诉或举报。<br>
            9.3本隐私政策的解释及争议解决均应适用中华人民共和国法律。与本隐私政策相关的任何纠纷，双方应友好协商解决；若不能协商解决或协商不成的，您同意将争议提交至有管辖权的人民法院诉讼解决。
        </div>

        <div class="privacy-t2">
            附件一：个人信息清单
        </div>


        <div class="privacy-table">
            <table>
                <thead>
                    <tr>
                        <th style="width: 0.6rem;">序号</th>
                        <th>功能</th>
                        <th>收集个人信息类型</th>
                        <th>个人信息处理方式</th>
                        <th>储存位置</th>
                        <th>储存期限</th>
                        <th>处理频次</th>
                        <th>是否涉及对外共享</th>
                        <th>是否对外公开披露</th>
                        <th>是否跨境</th>
                        <th>是否为使用第三方SDK</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>1</td>
                        <td colspan="10">目前不涉及此种数据处理场景</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="privacy-t2">
            附件二：SDK清单目录
        </div>

        <div class="privacy-table">
            <table>
                <thead>
                    <tr>
                        <th style="width: 0.6rem;">序号</th>
                        <th>SDK名称</th>
                        <th>SDK类型</th>
                        <th>SDK描述</th>
                        <th>SDK使用业<br>务场景</th>
                        <th>SDK所需用<br>户信息字段</th>
                        <th>使用目的/理由</th>
                        <th>收集的频率</th>
                        <th>是否去标识化/<br>匿名化传输</th>
                        <th>是否自启动、关<br>联启动、后台运行</th>
                        <th>SDK个人信息保护政<br>策链接</th>
                        <th>是否对此SDK有接入<br>管理、安全评估</th>
                        <th>涉及车型以及<br>车机平台</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>1</td>
                        <td>百度统计</td>
                        <td>统计分析类</td>
                        <td>用于统计官网访问量、用户点击、浏览时长等运营数据</td>
                        <td>官网访问统计</td>
                        <td>1.访问设备信息：IP地址（仅用于地域分析，去标识化处理）、设备型号、操作系统版本、屏幕分辨率、浏览器类型<br>
                            2.访问操作信息：访问页面、访问时长、访问频次、来源网址、站内搜索关键词（仅官网搜索场景）<br>
                            3.网络信息：网络运营商、网络类型（Wi‑Fi/移动网络）<br>
                            4.网络标识信息（Cookie）</td>
                        <td>辅助官网运营工作</td>
                        <td>每次访问、每次点击</td>
                        <td>是</td>
                        <td>无</td>
                        <td>https://tongji.baidu.<br>com/web/help/<br>article?id=330&<br>type=0&castk=LTE%3D</td>
                        <td>ISO29151个人数据隐私保护管理体系<br>
                            ISO27701隐私信息管理体系<br>
                            BS10012个人信息安全管理体系</td>
                        <td>不涉及</td>
                    </tr>
                </tbody>
            </table>
        </div>


        <div class="privacy-t2">
            附件三：个人信息对外提供清单
        </div>
        <div class="privacy-table">
            <table>
                <thead>
                    <tr>
                        <th style="width: 0.6rem;">序号</th>
                        <th>共享的个人信息类型</th>
                        <th>共享的原因</th>
                        <th>个人信息处理方式</th>
                        <th>对接收方的约束及管理准则</th>
                        <th>接收方使用个人信息的目的</th>
                        <th>共享过程中使用的安全措施</th>
                        <th>共享是否对个人信息主体带来高危风险</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>1</td>
                        <td colspan="10">目前不涉及此种数据处理场景</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="privacy-t2">
            附件四：个人信息对外公开披露清单
        </div>
        <div class="privacy-table">
            <table>
                <thead>
                    <tr>
                        <th style="width: 0.6rem;">序号</th>
                        <th>披露个人信息类型</th>
                        <th>披露原因</th>
                        <th>是否会对个人信息主体带来高风险</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>1</td>
                        <td colspan="10">目前不涉及此种数据处理场景</td>
                    </tr>
                </tbody>
            </table>
        </div>


    </div>
    <Footer></Footer>
</template>

<script setup>
import { ref, onMounted, nextTick, onUnmounted } from 'vue';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';

onMounted(() => {
})


onUnmounted(() => {
});



</script>

<script>
export const pageConfig = {
    title: '隐私政策 - 蜂巢汽车科技集团有限公司',
    keywords: '蜂巢,蜂巢汽车,发动机,变速箱,电子',
    description: '蜂巢汽车科技集团有限公司，是一家掌握从传统动力到混合动力再到纯电动力（含控制器）全领域动力总成、汽车智能化集成系统等核心技术的零部件企业，具备完整的软、硬件产业链；能为客户提供高效节能环保的汽车动力总成、智能化出行解决方案',
    outputPath: 'privacy.html'
};

import { createApp } from 'vue';
import App from './privacy.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss"
import { title } from 'process';

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}


// 页面加载完成后挂载
document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./privacy.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss">
.privacy-page {
    padding: 1.82rem 2.52rem;

    .privacy-title {
        font-size: 0.4rem;
        font-weight: 500;
        margin-bottom: 0.35rem;
    }

    .privacy-t1 {
        font-size: 0.25rem;
        font-weight: 500;
        margin-bottom: 0.35rem;
    }

    .privacy-t2 {
        font-size: 0.2rem;
        font-weight: 500;
        margin-bottom: 0.21rem;
    }

    .privacy-d1 {
        font-size: 0.16rem;
        font-weight: 400;
        line-height: 0.3rem;
        margin-bottom: 0.52rem;
        color: #656565;

        div {
            margin-bottom: 0.3rem;

            &:last-child {
                margin-bottom: 0;
            }
        }
    }

    table {
        width: 100%;
        border-collapse: collapse;
        margin-bottom: 0.35rem;

        th,
        td {
            border: 1px solid #002D4C;
            padding: 0.2rem 0.1rem;
            text-align: center;
            font-size: 0.12rem;
            max-width: 2rem;
        }

        th {
            background-color: #E3E8ED;
            text-wrap: nowrap;
        }
    }


    .privacy-cb {
        color: #000;
        font-weight: 500;
    }

    .privacy-fb {
        text-decoration: underline;
    }

    .privacy-cr {
        color: #E70012;

    }

    .p-l {
        padding-left: 0.5rem;
    }
}


@media (max-width: 768px) {
    .privacy-page {
        padding: 1.5rem .45rem;
        width: calc(100% - 0.9rem);

        .privacy-title {
            font-size: 0.5rem;
        }

        .privacy-t1 {
            font-size: 0.42rem;
        }

        .privacy-t2 {
            font-size: 0.36rem;
        }

        .privacy-d1 {
            font-size: 0.28rem;
            line-height: 0.5rem;
        }

        .privacy-table {
            overflow-x: auto;
            width: 100%;
        }

        table {
            width: auto;

            th,
            td {
                border: 1px solid #002D4C;
                padding: 0.2rem;
                font-size: 0.24rem;
                max-width: unset;
            }

            th {
                background-color: #E3E8ED;
                text-wrap: nowrap;
            }
        }
    }
}
</style>